import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation } from '@angular/core';
import { Checkpoint2MeasureUnitTypes, ICheckpointMeasureUnitData } from '@fi-shared/checklist/checklist-consts';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { Checkpoint2MeasureUnitType, CheckpointEditorFormModelNames } from '@fi-shared/checklist/checklist-enum';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';
import { FiCheckpoint2HelperService } from '@fi-shared/checklist/fi-checkpoint2-helper.service';

@Component({
    selector: 'fi-checkpoint-measure-unit-editor',
    template: `
        <p class="checkpoint-edit-section-name">{{ 'checklist.measure_unit' | fiAppText }}</p>
        <mat-form-field appearance="outline" class="custom-arrow-icon">
          <mat-label>{{ 'checklist.choose_measure_unit' | fiAppText }}</mat-label>
          <mat-select
            [(ngModel)]="ngModel"
            (ngModelChange)="doPropagateChanges()"
            panelClass="fi-rounded-select-panel"
            [required]="true"
            [name]="CheckpointEditorFormModelNames.MeasureUnit"
            #measureUnitTypeModel="ngModel"
            >
            @for (measureUnit of Checkpoint2MeasureUnitTypes; track measureUnit) {
              <mat-option [value]="measureUnit.id">
                <mat-icon [ngClass]="measureUnit.iconClass" />
                {{ getMeasureUnitText(measureUnit) }}
              </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix class="fas fa-caret-down" />
          <mat-error
            [fiErrorMessage]="measureUnitTypeModel"
            [fiErrorCustomMessages]="{ required: 'error.checkpoint_measure_unit_required' }"
            />
          </mat-form-field>
        `,
    styleUrl: './measure-unit-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-measure-unit-editor' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiCheckpointMeasureUnitEditorComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiCheckpointMeasureUnitEditorComponent,
        },
    ],
    standalone: false,
})
export class FiCheckpointMeasureUnitEditorComponent extends ControlValueAccessorValidatorBase<Checkpoint2MeasureUnitType> {
    protected readonly Checkpoint2MeasureUnitTypes = Checkpoint2MeasureUnitTypes;
    protected readonly CheckpointEditorFormModelNames = CheckpointEditorFormModelNames;

    constructor(
        injector: Injector,
        private appTextService: AppTextService,
        private fiCheckpoint2HelperService: FiCheckpoint2HelperService,
    ) {
        super(injector);
    }

    getMeasureUnitText(measureUnit: ICheckpointMeasureUnitData) {
        let text = this.appTextService.get(measureUnit.textId);
        const shortText = this.fiCheckpoint2HelperService.getCheckpointMeasureUnitShortText(measureUnit.id);
        if (shortText) {
            text += ' - ' + shortText;
        }
        return text;
    }
}
